import type { TPageTranslations } from '@crehana/i18n';

import { PAGE_KEY } from './constants';
import type { TKeys } from './types';

export const pt: TPageTranslations<TKeys, typeof PAGE_KEY> = {
  [PAGE_KEY]: {
    // SEO
    SEO_TITLE: 'Detalhe do colaborador | Alertas legais México | Crehana',
    SEO_DESCRIPTION:
      'Consulte o detalhamento semanal de horas extras de um colaborador frente aos limites legais do México.',

    // Header
    HEADER_TITLE: 'Detalhe do colaborador',
    HEADER_TITLE_WITH_NAME: 'Detalhe do colaborador: {{name}}',
    BUTTON_BACK: 'Voltar',

    // Week navigator
    WEEK_NAVIGATOR_LABEL: 'Semana de {{start}} a {{end}}',
    WEEK_NAVIGATOR_PREV: 'Semana anterior',
    WEEK_NAVIGATOR_NEXT: 'Próxima semana',
    // Same MR !257 rationale as EDIT_WORKDAY_DIALOG_TITLE_DATE_PATTERN: the
    // "de" connector needs its own value per locale.
    WEEK_NAVIGATOR_END_DATE_PATTERN: "d 'de' MMMM, yyyy",
    WEEK_NAVIGATOR_START_DATE_PATTERN_CROSS_MONTH: "d 'de' MMMM",

    // State labels
    STATE_NO_ALERTS: 'Sem alertas',
    STATE_AT_RISK: 'Em risco',
    STATE_EXCEEDED: 'Excedido',
    STATE_NO_DATA: 'Sem dados',

    // Table
    DETAIL_TABLE_TITLE: 'Detalhe de alertas legais',

    // Columns
    COL_DATE: 'Data',
    COL_SHIFT: 'Turno do dia',
    COL_WORKED_TIME: 'Tempo trabalhado',
    COL_EXTRA_TIME: 'Tempo extra',
    COL_COMPENSATED_TIME: 'Tempo de compensação',
    COL_STATE: 'Status',

    // Rows
    CAP_LABEL: 'Limite: {{value}}',
    // !402 review, hilo DOS — a PROPOSAL, pending Laura's confirmation. Do
    // not mark this copy as approved.
    CAP_LABEL_NOT_EVALUATED: 'Limite legal: {{value}}',
    ROW_TOTAL: 'Total da semana',
    TODAY_LABEL: 'Hoje',
    EMPTY_VALUE: '—',

    // Errors
    FORBIDDEN_TITLE: 'Você não tem acesso',
    FORBIDDEN_DESCRIPTION: 'Você não tem permissão para ver esta informação.',
    NOT_AUTHENTICATED_TITLE: 'Sua sessão não é válida',
    NOT_AUTHENTICATED_DESCRIPTION:
      'Faça login novamente para ver o detalhe do colaborador.',
    VALIDATION_TITLE: 'O colaborador não é válido',
    VALIDATION_DESCRIPTION:
      'Verifique o link ou volte à lista de alertas legais.',
    BUTTON_BACK_TO_LIST: 'Voltar à lista',
    ERROR_TITLE: 'Ocorreu um erro',
    ERROR_DESCRIPTION: 'Ocorreu um erro. Clique no botão para tentar de novo.',
    ERROR_RETRY: 'Tentar novamente',
  },
};
